// Appears only when something is selected (customers/products/users
// multi-select task: "a bulk action bar that appears only when something is
// selected"). Generic across the three screens that use it — a selection
// count plus whatever actions that screen passes in; no per-resource
// knowledge lives here.

import { Spinner } from 'shared/components/Feedback/index.js';
import { useLanguage } from '../context/LanguageContext.jsx';
import styles from './BulkActionBar.module.css';

// `actions`: [{ id, labelId, tone: 'default' | 'danger', onClick, pending }]
export default function BulkActionBar({ count, actions, onClear }) {
  const { t } = useLanguage();
  if (count === 0) return null;

  return (
    <div className={styles.bar} role="toolbar" aria-label={t('bulk.barLabel')}>
      <span className={`${styles.count} tabularNums`}>{t('bulk.selectedCount', { count })}</span>
      <div className={styles.actions}>
        {actions.map((action) => (
          <button
            key={action.id}
            type="button"
            className={`${styles.actionButton} ${
              action.tone === 'danger' ? styles.actionButtonDanger : ''
            }`}
            onClick={action.onClick}
            disabled={action.pending}
          >
            {action.pending && <Spinner />} {t(action.labelId)}
          </button>
        ))}
        <button type="button" className={styles.clearButton} onClick={onClear}>
          {t('bulk.clearSelection')}
        </button>
      </div>
    </div>
  );
}
